import { useQuery } from '@tanstack/react-query';
import { getCurrentFormulation } from '@/services/flavor_versions_api';

export const currentFormulationQueryKey = (flavorId: string, formulaId: number) =>
  ['flavorVersion', flavorId, formulaId, 'current'] as const;

export function useCurrentFormulation(flavorId: string, formulaId: number) {
  return useQuery({
    queryKey: currentFormulationQueryKey(flavorId, formulaId),
    queryFn: () => getCurrentFormulation(flavorId, formulaId),
    // Two callers pass `0` as a fallback when the formula id isn't loaded
    // yet (FlaskMoreMenu, PrintFlaskPage). The server's Zod schema rejects
    // fid<=0 with 400; gate the query so it only fires when both ids are
    // valid.
    enabled: !!flavorId && formulaId > 0,
    staleTime: 30_000,
  });
}
